export default {
    title: 'Evaluation summary',
    data: '{count} macro-trends in {type}',
    button: 'Analyze evaluation'
}
